import { useState } from 'react';
import { MagnifyingGlassIcon, SparklesIcon, ArrowTrendingUpIcon } from '@heroicons/react/24/outline';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

const popularSearches = [
  'Reset password',
  'Video call help',
  'Emergency features',
  'Family dashboard',
  'Privacy settings',
  'Health tracking',
  'Medication reminders',
  'Community features'
];

const SearchSection = () => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (query: string) => {
    setSearchQuery(query);
    if (query.trim()) {
      // Navigate to support page with search query
      window.location.href = `/support?search=${encodeURIComponent(query.trim())}`;
    }
  };

  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-foreground mb-4">
              Find Answers <span className="text-primary">Instantly</span>
            </h2>
            <p className="text-lg text-muted-foreground">
              Our smart search understands what you're looking for, even if you're not sure how to ask it.
            </p>
          </div>

          <div className="relative mb-8">
            <div className="relative">
              <MagnifyingGlassIcon className="absolute left-4 top-1/2 transform -translate-y-1/2 h-5 w-5 text-muted-foreground" />
              <Input
                type="text"
                placeholder="What can we help you with today? Try 'how to make a video call' or 'emergency button'"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="pl-12 pr-24 py-4 text-lg rounded-lg border-2 focus:border-primary"
              />
              <Button 
                className="absolute right-2 top-1/2 transform -translate-y-1/2"
                onClick={() => handleSearch(searchQuery)}
              >
                <SparklesIcon className="h-4 w-4 mr-2" />
                Search
              </Button>
            </div>
          </div>

          <div className="bg-muted/50 rounded-lg p-6">
            <div className="flex items-center mb-4">
              <ArrowTrendingUpIcon className="h-5 w-5 text-primary mr-2" />
              <h3 className="text-lg font-semibold text-foreground">Popular Searches</h3>
            </div>
            <div className="flex flex-wrap gap-2">
              {popularSearches.map((search) => (
                <button
                  key={search}
                  onClick={() => handleSearch(search)}
                  className="bg-card border rounded-full px-4 py-2 text-sm text-muted-foreground hover:text-primary hover:border-primary transition-colors"
                >
                  {search}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SearchSection;